<template>
  <el-dialog
    title="调整考试次数"
    width="540px"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <el-form
      ref="formEl"
      :model="form"
      :rules="rules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="调整考试次数：" prop="num">
        <el-input-number v-model="form.num" :min="1" :max="100" :step-strictly="true" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关 闭</el-button>
      <el-button :loading="saveing" size="small" type="primary" @click="handleAffirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { numOperateUpdate } from "@/api/product/base"

export default {
  name: 'ManageExamNum',

  data () {
    return {
      dialogVisible: false,
      form: {
        num: 1,
      },
      rules: {
        num: [
          { required: true, message: "请输入调整考试次数!", trigger: "blur" },
        ]
      },
      saveing: false
    }
  },
  methods: {
    init (payload) {
      this.form.num = payload.canAppointNum
      this.form.id = payload.id
      this.dialogVisible = true
    },
    handleAffirm () {
      this.$refs.formEl.validate(valid => {
        if (valid) {
          this.saveing = true
          const params = {
            ...this.form
          }
          numOperateUpdate(params).then(({ code }) => {
            if (code === 0) {
              this.$message.success('调整考试次数成功!')
              this.$emit('refresh')
              this.handleClose()
            }
          }).finally(() => {
            this.saveing = false
          })
        }
      })
    },
    handleClose () {
      this.form = this.$options.data().form
      this.$refs.formEl && this.$refs.formEl.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style>

</style>
